import React from 'react';
import { Box, Typography } from '@mui/material';
import Pagination from '../../../components/FlowBuilder/Common/Pagination/index.tsx';
import useUserSx from '../hooks/useUserSx';

function getRangeLabel(page, pageSize, total) {
  if (!total) return 'Showing 0 users';
  const start = page * pageSize + 1;
  const end = Math.min((page + 1) * pageSize, total);
  return `Showing ${start}-${end} of ${total} user${total === 1 ? '' : 's'}`;
}

export default function UserTableFooter({
  count = 0,
  page = 0,
  pageSize = 20,
  onPageChange,
  onPageSizeChange,
}) {
  const { tableFooter } = useUserSx();

  const handleChangePage = (_event, newPage) => {
    onPageChange?.(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    const nextPageSize = parseInt(event.target.value, 10) || pageSize;
    onPageSizeChange?.(nextPageSize);
  };

  return (
    <Box sx={tableFooter.root}>
      <Typography sx={tableFooter.summary}>{getRangeLabel(page, pageSize, count)}</Typography>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Pagination
          totalCount={count}
          rowsPerPage={pageSize}
          page={page}
          handleChangePage={handleChangePage}
          handleChangeRowsPerPage={handleChangeRowsPerPage}
        />
      </Box>
    </Box>
  );
}
